<template>
    <a
        class="functional-button"
        href="#"
        @click.prevent="editPlayer"
    >
        <i class="far fa-code" />
        <span>Embed code</span>
    </a>
</template>

<script>
export default {
    props: {
        playerType: {
            type: String,
            required: true,
        },
        player: {
            type: Object,
            default: () => ({}),
        },
        trackNo: {
            type: String,
            default: '1:0',
        },
        trackGuid: {
            type: String,
            default: null,
        },
    },

    methods: {
        /**
         * Handle click based on player type
         *
         */
        editPlayer() {
            if ('archive' === this.playerType) {
                this.$emit('click', {
                    editPlayerType: this.playerType,
                    player: this.player,
                    showEmbed: true,
                });
            } else {
                this.$emit('click', {
                    trackNo: this.trackNo,
                    trackGuid: this.trackGuid,
                });
            }
        },
    },
};
</script>
